import { ItemText, Main } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import ResumeDownload from 'components/ResumeDownload'
import ResumePreview, { getUploadedCvUrl } from 'components/ResumePreview'
import EmailIcon from 'components/icons/EmailIcon'
import PhoneIcon from 'components/icons/PhoneIcon'
import VerticalThreeDots from 'components/icons/VerticalThreeDots'
import YellowStartIcon from 'components/icons/YellowStartIcon'
import DriveStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import {
  ContactFlex,
  DropBtn,
  DropDown,
  EmailIdDiv,
  HeaderFlex,
  IconSpan,
  NameDive,
  RatingText,
  RatingsDiv,
  StatusWrapper,
  StyledTab,
  TestDetailsFlex,
  TestFlex,
  ThreeDotsDiv,
  TopFlex,
  TopRightFlex,
  YellowStartSpan,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/style'
import React from 'react'
import { useSelector } from 'react-redux'
import RoundsSteps from '../../InterviewDetails/index'

const { TabPane } = StyledTab

const CandidateInfo = ({
  candidateInfo,
  setCandidateInfo,
  scheduleDrawer,
  setScheduleDrawer,
  candidateDetails,
  addCorporateBranch,
  rolesMetrics,
  candidateInterviewDetails,
  candidateInfoData,
  updateInterviewStatus,
  getCandidateList,
  selectedRoundType,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  getSingleCandidateInterviewDetails,
  notifyReschedule,
  getRoleRounds,
  roundItemList,
  setCandidateInfoData,
  interViewerList,
  createInterview,
  driveInterViewerList,
  getDriveInterviewerList,
  driveData,
  getInterViewLocation,
  interViewData,
  corporateLocationsList,
  getCorporateLocationsList,
  getGroupDiscussionList,
  groupList,
  UpdateScheudle,
  ids,
  setNotification,
  notificationData,
  reasonItem,
  getRescheduleList,
  getDriveRoleCandidatesList,
}) => {
  const onClickOffer = () => {
    setCandidateInfo(false)
  }

  const promotionData = useSelector(state => state?.corporate?.promotionData)

  // Show the CV the candidate uploaded for this role; fall back to the
  // generated system resume only when they never uploaded one.
  const uploadedCvUrl = getUploadedCvUrl(notifyReschedule?.studentRoleMapping)
  const candidateFullName =
    `${candidateDetails?.firstName || ''} ${candidateDetails?.lastName || ''}`.trim() ||
    'This candidate'

  const items = [
    {
      key: 'download',
      label: (
        <ResumeDownload
          triggerButton={<ItemText weight={400}>Download Resume</ItemText>}
          studentDetails={candidateDetails}
          roleId={notifyReschedule?.studentRoleMapping?.roleId}
        />
      ),
    },
    notifyReschedule?.status === 'SELECTED' && {
      key: 'upload',
      label: (
        <ItemText weight={400} onClick={onClickOffer}>
          Release Offer
        </ItemText>
      ),
    },
  ]

  const title = () => {
    return (
      <HeaderFlex row spaceBetween centerVertically>
        <TopFlex row centerVertically>
          <AntdAvatar
            size={90}
            src={notifyReschedule?.student?.profileUrl}
            IconName={notifyReschedule?.student?.firstName
              .toUpperCase()
              ?.charAt(0)}
          />
          <ContactFlex column>
            <Flex centerVertically>
              <NameDive>
                {notifyReschedule?.student?.firstName}{' '}
                {notifyReschedule?.student?.middelName}{' '}
                {notifyReschedule?.student?.lastName}{' '}
              </NameDive>
              <StatusWrapper>
                <DriveStatus
                  status={notifyReschedule?.status}
                  offerStatus={notifyReschedule?.offerStatus}
                />
              </StatusWrapper>
            </Flex>
            {!!notifyReschedule?.student?.studentPersonalProfile
              ?.secondaryEmail && (
              <EmailIdDiv>
                <IconSpan>
                  <EmailIcon />
                </IconSpan>
                {
                  notifyReschedule?.student?.studentPersonalProfile
                    ?.secondaryEmail
                }
              </EmailIdDiv>
            )}
            {!!notifyReschedule?.student?.studentPersonalProfile
              ?.phoneNumber && (
              <EmailIdDiv>
                <IconSpan>
                  <PhoneIcon />
                </IconSpan>
                {notifyReschedule?.student?.studentPersonalProfile?.phoneNumber}
              </EmailIdDiv>
            )}
          </ContactFlex>
        </TopFlex>
        <TopRightFlex row spaceBetween centerVertically>
          <Flex row centerVertically>
            <TestDetailsFlex column>
              <RatingsDiv>
                {Number(notifyReschedule?.studentRoleMapping?.rating)?.toFixed(
                  2
                )}
                <YellowStartSpan>
                  <YellowStartIcon />
                </YellowStartSpan>
              </RatingsDiv>
              <RatingText>RATINGS</RatingText>
            </TestDetailsFlex>

            <TestFlex column>
              <RatingsDiv>{notifyReschedule?.stage?.toLowerCase()}</RatingsDiv>
              <RatingText>Stage</RatingText>
            </TestFlex>
          </Flex>
          <ThreeDotsDiv>
            <Main>
              <DropDown menu={{ items }} trigger={['click']}>
                <DropBtn>
                  <VerticalThreeDots />
                </DropBtn>
              </DropDown>
            </Main>
          </ThreeDotsDiv>
        </TopRightFlex>
      </HeaderFlex>
    )
  }
  const content = () => {
    return (
      <div>
        <StyledTab>
          <TabPane tab={<>Interview</>} key="1">
            <RoundsSteps
              candidateInfo={candidateInfo}
              setCandidateInfo={setCandidateInfo}
              scheduleDrawer={scheduleDrawer}
              setScheduleDrawer={setScheduleDrawer}
              rolesMetrics={rolesMetrics}
              candidateInfoData={candidateInfoData}
              updateInterviewStatus={updateInterviewStatus}
              addCorporateBranch={addCorporateBranch}
              getCandidateList={getCandidateList}
              selectedRoundType={selectedRoundType}
              getRoleMetrics={getRoleMetrics}
              setSelectedCandidate={setSelectedCandidate}
              setSelectedCandidateId={setSelectedCandidateId}
              getSingleCandidateInterviewDetails={
                getSingleCandidateInterviewDetails
              }
              candidateInterviewDetails={candidateInterviewDetails}
              notifyReschedule={notifyReschedule}
              getRoleRounds={getRoleRounds}
              roundItemList={roundItemList}
              getListOfCountries={getListOfCountries}
              getListOfStates={getListOfStates}
              getListOfCities={getListOfCities}
              interViewerList={interViewerList}
              createInterview={createInterview}
              driveInterViewerList={driveInterViewerList}
              getDriveInterviewerList={getDriveInterviewerList}
              driveData={driveData}
              getInterViewLocation={getInterViewLocation}
              interViewData={interViewData}
              listOfCountries={listOfCountries}
              listOfStates={listOfStates}
              listOfCities={listOfCities}
              setCandidateInfoData={setCandidateInfoData}
              corporateLocationsList={corporateLocationsList}
              getCorporateLocationsList={getCorporateLocationsList}
              groupList={groupList}
              getGroupDiscussionList={getGroupDiscussionList}
              UpdateScheudle={UpdateScheudle}
              ids={ids}
              setNotification={setNotification}
              notificationData={notificationData}
              reasonItem={reasonItem}
              getRescheduleList={getRescheduleList}
              getDriveRoleCandidatesList={getDriveRoleCandidatesList}
            />
          </TabPane>
          <TabPane tab={<>Resume</>} key="2">
            {/* The uploaded CV only — a candidate with no upload reads as
                "No resume found" rather than a resume we generated. */}
            <ResumePreview
              cvUrl={uploadedCvUrl}
              studentId={candidateDetails?.id}
              roleId={notifyReschedule?.studentRoleMapping?.roleId}
              candidateName={candidateFullName}
            />
          </TabPane>
        </StyledTab>
      </div>
    )
  }
  const footer = () => {}
  return (
    <Drawer
      width="65%"
      title={title()}
      placement="right"
      padding="0 30px 30px 30px"
      visible={candidateInfo}
      content={content()}
      footer={footer()}
      onClose={() => {
        setCandidateInfo(false)
      }}
    />
  )
}

export default CandidateInfo
